<template>
    <div class="container">
        <div class="filter-box">
            <p class="icon-arrow" :class="{'active' : filterFloat == true}" @click="filterFloat = !filterFloat">数据筛选</p>
            <p class="icon-arrow" :class="{'active' : sortFloat == true}" @click="sortFloat = !sortFloat">排序</p>
        </div>
        <div class="time-box icon-time icon-arrow" @click="timeFloat = true">{{time1}}-{{time1 == time2 ? '至今' : time2}}</div>
        <div class="rank-list">
            <div class="rank-tt">
                <p v-if="tap == 'user_id'">直销员姓名</p>
                <p v-if="tap == 'office'">办事处</p>
                <p v-if="tap == 'city'">城市</p>
                <p>视频案例</p>
                <p>口碑案例</p>
                <p>套购案例</p>
                <p>全部案例</p>
            </div>
            <div class="rank-main">
                <pull-to :top-load-method="downRefresh" :bottom-load-method="upRefresh" :top-config="TOP_DEFAULT_CONFIG" :bottom-config="BOTTOM_DEFAULT_CONFIG" :is-bottom-bounce="true" bottom-block-height:0 top-block-height:0>
                    <div class="item" v-for="(item,index) in list">
                        <p>{{item.name}}</p>
                        <p>{{item.video}}</p>
                        <p>{{item.praise}}</p>
                        <p>{{item.suit}}</p>
                        <p>{{item.total}}</p>
                        <p class="sort">{{index+1}}</p>
                    </div>
                </pull-to>
            </div>
        </div>

        <!-- 排序 -->
        <div class="sort-float" v-if="sortFloat">
            <div class="close" @click="getDate(false)"></div>
            <div class="sort-dialog">
                <div class="item" :class="{'active' : selectData.sort == 'video_high'}" @click="setsort('video_high')">视频案例由高到低</div>
                <div class="item" :class="{'active' : selectData.sort == 'video_low'}" @click="setsort('video_low')">视频案例由低到高</div>
                <div class="item" :class="{'active' : selectData.sort == 'praise_high'}" @click="setsort('praise_high')">口碑案例由高到低</div>
                <div class="item" :class="{'active' : selectData.sort == 'praise_low'}" @click="setsort('praise_low')">口碑案例由低到高</div>
                <div class="item" :class="{'active' : selectData.sort == 'suit_high'}" @click="setsort('suit_high')">套购案例由高到低</div>
                <div class="item" :class="{'active' : selectData.sort == 'suit_low'}" @click="setsort('suit_low')">套购案例由低到高</div>
                <div class="item" :class="{'active' : selectData.sort == 'total_high'}" @click="setsort('total_high')">全部案例由高到低</div>
                <div class="item" :class="{'active' : selectData.sort == 'total_low'}" @click="setsort('total_low')">全部案例由低到高</div>
            </div>
        </div>

        <!-- 办事处 -->
        <div class="office-float" v-if="officeFloat">
            <div class="search-box">
                <input type="text" placeholder="选择办事处" v-model="office" @input="searchOffice">
            </div>
            <div class="list">
                <div class="item" :class="{'active' : isSelectAllOffice}" @click="selectOfficeAll">全部</div>
                <div class="item" :class="{'active' : item.select}" v-for="(item,index) in dataList.office" @click="addOffice(index)">{{item.name}}</div>
            </div>
            <div class="confirm">
                <div class="btn" @click="officeFloat = false">确定</div>
            </div>
        </div>

        <!-- 时间 -->
        <div class="time-float" v-if="timeFloat">
            <span class="close" @click="timeFloat = false"></span>
            <div class="time-dialog">
                <div class="day-tab">
                    <div class="item" :class="{'active' : timeActive == 1}" @click="lessTime(1)">昨天</div>
                    <div class="item" :class="{'active' : timeActive == 7}" @click="lessTime(7)">近7天</div>
                    <div class="item" :class="{'active' : timeActive == 30}" @click="lessTime(30)">近30天</div>
                </div>
                <div class="time-main">
                    <h3>自定义</h3>
                    <div class="time">
                        <p @click="openPicker('picker1')">{{time1 || '请选择'}}</p>
                        <span>至</span>
                        <p @click="openPicker('picker2')">{{time2 || '请选择'}}</p>
                    </div>
                </div>
                <div class="footer-btn">
                    <div class="btn" @click="resetTime">重置</div>
                    <div class="btn active" @click="downRefresh">确定</div>
                </div>
            </div>
        </div>

        <!-- 过滤 -->
        <div class="filter-float" v-if='filterFloat'>
            <div class="close" @click="filterFloat = false"></div>
            <div class="list">
                <div class="item-box">
                    <h3>各大区(可多选)</h3>
                    <div class="list">
                        <div class="item" :class="{'active' : item.select}" v-for="(item,index) in dataList.area" @click="addArea(index)">{{item.name}}</div>
                    </div>
                </div>
                <div class="item-box">
                    <h3 class="icon-arrow2" @click="officeFloat = true">选择办事处(可多选)</h3>
                    <div class="txt">{{officeArr()}}</div>
                </div>
                <div class="item-box">
                    <h3>数据指标(只可选者一项)</h3>
                    <div class="list">
                        <div class="item" :class="{'active' : selectData.target == 'forward'}" @click="selectData.target = 'forward'">案例转发量</div>
                        <div class="item" :class="{'active' : selectData.target == 'release'}" @click="selectData.target = 'release'">案例上传量</div>
                    </div>
                </div>
                <div class="item-box">
                    <h3>选择品类(可多选)</h3>
                    <div class="list">
                        <template v-if="!categorySelectAll">
                            <div class="item" :class="{'active' : item.select}" v-for="(item,index) in dataList.category" @click="addCategory(index)" :key="index">
                                {{item.name}}
                            </div>
                        </template>
                        <div class="item" :class="{'active' : categorySelectAll}" @click="selectAll">
                            全部
                        </div>
                    </div>
                </div>
                <div class="item-box">
                    <h3>人员属性(可多选)</h3>
                    <div class="list">
                        <div class="item" :class="{'active' : selectData.attr[0] == 'ao'}" @click="addAttr(0,'ao')">AO人员</div>
                        <div class="item" :class="{'active' : selectData.attr[1] == 'dl'}" @click="addAttr(1,'dl')">代理商人员</div>
                    </div>
                </div>
            </div>
            <div class="footer-btn">
                <p class="btn" @click="filterFloat = false">取消</p>
                <p class="btn active" @click="downRefresh">确定</p>
            </div>
        </div>

        <mt-datetime-picker ref="picker1" v-model="pickerVisible1" type="date" :endDate="new Date()" year-format="{value} 年" month-format="{value} 月" @confirm="dateConfirm()" date-format="{value} 日">
        </mt-datetime-picker>

        <mt-datetime-picker v-model="pickerVisible2" ref="picker2" type="date" :startDate="pickerVisible1" :endDate="new Date()" @confirm="dateConfirm()" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日">
        </mt-datetime-picker>
    </div>
</template>

<script>
import path from "@/path.js";
import PullTo from "vue-pull-to";
var isLoadNoData = false;
var officeArr = [];
export default {
    components: {
        PullTo,
    },
    data() {
        return {
            categorySelectAll: false,
            pickerVisible1: new Date(
                `${new Date().getFullYear()}/${new Date().getMonth() + 1}/01`
            ),
            pickerVisible2: new Date(),
            time1: "",
            time2: "",
            timeActive: 0,

            office: "",
            isSelectAllOffice: false,
            filterFloat: false,
            timeFloat: false,
            sortFloat: false,
            officeFloat: false,
            dataList: {
                area: [],
                category: [],
                office: [],
            },

            selectData: {
                target: "",
                attr: [],
                sort: "",
            },
            list: [],
            tap: "",

            page: 1, //页码
            TOP_DEFAULT_CONFIG: {
                pullText: "下拉刷新", // 下拉时显示的文字
                triggerText: "释放更新", // 下拉到触发距离时显示的文字
                loadingText: "加载中...", // 加载中的文字
                doneText: "加载完成", // 加载完成的文字
                failText: "加载失败", // 加载失败的文字
                loadedStayTime: 400, // 加载完后停留的时间ms
                stayDistance: 50, // 触发刷新后停留的距离
                triggerDistance: 70, // 下拉刷新触发的距离
            },
            BOTTOM_DEFAULT_CONFIG: {
                pullText: "加载中...",
                triggerText: "加载中...",
                loadingText: "加载中...",
                doneText: "加载中...",
                failText: "加载中...",
                loadedStayTime: 0,
                stayDistance: 10,
                triggerDistance: 10,
                bShowloading: true,
            },
        };
    },
    created() {
        this.time1 = this.formatDate(this.pickerVisible1);
        this.time2 = this.formatDate(this.pickerVisible2);
        this.tap = this.$route.query.type;
        //  console.log(this.$route.query)
        isLoadNoData = false;
        path.post5(path.praiseFilterIng, {}).then((res) => {
            if (res.data.error == 0) {
                for (let key in res.data.data.result) {
                    let item = res.data.data.result[key];
                    for (let subitem of item) {
                        subitem.select = false;
                    }
                }
                this.dataList = res.data.data.result;
                officeArr = this.dataList.office;
            }
        });

        this.getDate();
    },
    methods: {
        setsort(val) {
            this.selectData.sort = val;
            this.page = 1;
            this.list = [];
            this.getDate();
        },
        openPicker(picker) {
            this.$refs[picker].open();
        },
        dateConfirm() {
            this.time1 = this.formatDate(this.pickerVisible1);
            this.time2 = this.formatDate(this.pickerVisible2);
        },
        formatDate(date) {
            // 格式化日期为 y-m-d H:i:s
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + m + "-" + d;
        },
        //下拉
        downRefresh(loaded) {
            isLoadNoData = false;
            this.page = 1;
            this.list = [];
            this.getDate();
            if(!(typeof loaded === "function")) return false
            loaded("done");
        },
        //上拉
        upRefresh(loaded) {
            if (!isLoadNoData) {
                let page = this.page + 1;
                this.page = page;
                this.getDate(page);
            }
            loaded("done");
            //console.log("2");
        },

        lessTime(day) {
            var today = new Date();
            var lastOrNextDate = today.getTime() - 1000 * 60 * 60 * 24 * day;
            today.setTime(lastOrNextDate);
            var year = today.getFullYear();
            var month = today.getMonth() + 1;
            var date = today.getDate();
            month = month < 10 ? "0" + month : month;
            date = date < 10 ? "0" + date : date;
            this.pickerVisible1 = new Date(today);
            this.pickerVisible2 = new Date();
            this.time1 = year + "-" + month + "-" + date;
            this.time2 = this.formatDate(new Date());
            this.timeActive = day;
        },
        resetTime() {
            this.time1 = "";
            this.time2 = "";
        },

        searchOffice() {
            let arr = [];
            for (let item of officeArr) {
                if (item.name.indexOf(this.office) != -1) {
                    arr.push(item);
                }
            }
            this.dataList.office = arr;
        },
        selectOfficeAll() {
            let select = false;
            if (this.isSelectAllOffice) {
                this.isSelectAllOffice = false;
            } else {
                select = true;
                this.isSelectAllOffice = true;
            }

            for (let item of this.dataList.office) {
                item.select = select;
            }
        },
        officeArr() {
            let str = "";
            for (let item of this.dataList.office) {
                if (item.select) {
                    str += item.name + "、";
                }
            }
            return str || "请选择";
        },
        selectOffice() {},
        addOffice(index) {
            this.dataList.office[index].select =
                !this.dataList.office[index].select;
        },
        addArea(index) {
            this.dataList.area[index].select =
                !this.dataList.area[index].select;
        },
        addCategory(index) {
            this.dataList.category[index].select =
                !this.dataList.category[index].select;
        },
        addAttr(index, key) {
            if (this.selectData.attr[index]) {
                this.$set(this.selectData.attr, index, "");
            } else {
                this.$set(this.selectData.attr, index, key);
            }
        },
        getDate(flag) {
            if (flag === false) {
                this.sortFloat = false;
                return;
            }
            let areaArr = [];
            let officeArr = [];
            let categoryArr = [];
            for (let key in this.dataList) {
                let item = this.dataList[key];
                for (let subitem of item) {
                    if (subitem.select) {
                        if (key == "area") {
                            areaArr.push(subitem.id);
                        } else if (key == "office") {
                            officeArr.push(subitem.id);
                        } else {
                            categoryArr.push(subitem.id);
                        }
                    }
                }
            }
            let obj = {
                type: this.$route.query.type,
                start_date: this.time1,
                end_date: this.time2,
                order: this.selectData.sort,
                area: JSON.stringify(areaArr),
                office: JSON.stringify(officeArr),
                category: JSON.stringify(categoryArr),
                target: this.selectData.target,
                attr: JSON.stringify(this.selectData.attr),
                page: this.page,
                size: 10,
            };
            if (this.categorySelectAll) {
                obj.category = "[]";
            }
            this.$store.commit("loadSwitch", true);
            path.post5(path.praiseRankMinute, obj).then((res) => {
                this.$store.commit("loadSwitch", false);
                if (res.data.error == 0) {
                    if (res.data.data.result.rank.length) {
                        this.list.push(...res.data.data.result.rank);
                    } else {
                        isLoadNoData = true;
                    }
                }
            });

            this.sortFloat = false;
            this.officeFloat = false;
            this.filterFloat = false;
            this.timeFloat = false;
        },
        // 选择全部品类
        selectAll() {
            this.categorySelectAll = !this.categorySelectAll;
            // console.log(this.dataList.category)
            this.dataList.category.forEach(item => {
                item.select = this.categorySelectAll ? true : false
            })
        }
    }
}
</script>


<style lang="scss" scoped>
@import "./report";
.container {
    padding-top: 120px;
}
.rank-list .rank-tt p:first-child {
    width: 15rem;
}
.rank-list .rank-main .item p:first-child {
    width: 9rem;
}
.rank-list .rank-main .item p {
    width: 60%;
}
</style>
